import React from 'react';
import { getVersion } from 'utils/getVersion';

function Version() {
  return <p>{`v. ${getVersion()}`}</p>;
}

export default Version;
